// db.js

import Firebase from 'firebase'
// Initialize Firebase

//Use this for dev alias
var devConfig = {
  apiKey: "AIzaSyDaIkVTyheD7d7O8hwrAymhsTrJk9ctLe0",
  authDomain: "owqlo-project-dev.firebaseapp.com",
  databaseURL: "https://owqlo-project-dev.firebaseio.com",
  projectId: "owqlo-project-dev",
  storageBucket: "owqlo-project-dev.appspot.com",
  messagingSenderId: "589646566478"
};

//Use this for prod alias
var prodConfig = {
  apiKey: "AIzaSyDuqBa2W0CrUKq0rEstTJkLvZoc_jvZIto",
  authDomain: "owqlo-project-prod.firebaseapp.com",
  databaseURL: "https://owqlo-project-prod.firebaseio.com",
  projectId: "owqlo-project-prod",
  storageBucket: "owqlo-project-prod.appspot.com",
  messagingSenderId: "538299491876"
};

let app = Firebase.initializeApp(prodConfig)
export const db = app.database()
export const storage = app.storage()
export const auth = app.auth()
export const functions = app.functions()